/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g

export function isUrl (path) {
  return reg.test(path)
}

const menuData = [
  {
    name: '仪表盘',
    icon: 'dashboard',
    path: 'dashboard',
    children: [
      {
        name: '金价看板',
        path: 'analysis',
      }
    ]
  },
]

function formatter (data, parentPath = '/', parentAuthority) {
  return data.map(item => {
    let {path} = item
    if (!isUrl(path)) {
      path = parentPath + item.path
    }
    const result = {
      ...item,
      path,
      authority: item.authority || parentAuthority,
    }
    if (item.children) {
      result.children = formatter(item.children, `${parentPath}${item.path}/`, item.authority)
    }
    return result
  })
}

export const getMenuData = () => formatter(menuData)



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/menu.js